import { render, staticRenderFns } from "./LightScrollableTableRow.vue?vue&type=template&id=a3998922&scoped=true&"
import script from "./LightScrollableTableRow.vue?vue&type=script&lang=ts&"
export * from "./LightScrollableTableRow.vue?vue&type=script&lang=ts&"
import style0 from "./LightScrollableTableRow.vue?vue&type=style&index=0&id=a3998922&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3998922",
  null
  
)

export default component.exports